import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('selectPanel');

    return {
        NO_ITEMS_FOUND: t('noItemsFound')
    };
};

export default useTranslation;
